module.exports = __webpack_public_path__ + "img/GS_Profile-Kgomotso Queen Matshe.cdc906fb.png";